import {
  pgTable,
  serial,
  varchar,
  integer,
  text,
  timestamp,
  index,
} from "drizzle-orm/pg-core";

// Append-only log of every AI call made through the tracked client
// (server/services/ai). One row per call: cost, latency, outcome, and the
// entity it worked on. No foreign keys — logs must never block or cascade.
export const aiCallLogs = pgTable(
  "ai_call_logs",
  {
    id: serial("id").primaryKey(),
    feature: varchar("feature", { length: 50 }).notNull(), // e.g. "rfp_analysis"
    model: varchar("model", { length: 100 }).notNull(),
    promptTokens: integer("prompt_tokens"),
    completionTokens: integer("completion_tokens"),
    totalTokens: integer("total_tokens"),
    latencyMs: integer("latency_ms"),
    estimatedCostCents: integer("estimated_cost_cents"),
    status: varchar("status", { length: 20 }).notNull(), // success | error | timeout
    errorMessage: text("error_message"),
    entityType: varchar("entity_type", { length: 50 }), // e.g. "quote"
    entityId: integer("entity_id"),
    // Nullable + no FK: logs never block, and some calls have no agency context.
    agencyId: varchar("agency_id"),
    createdAt: timestamp("created_at").defaultNow().notNull(),
  },
  (table) => ({
    featureIdx: index("idx_ai_call_logs_feature").on(table.feature),
    createdAtIdx: index("idx_ai_call_logs_created_at").on(table.createdAt),
    featureCreatedIdx: index("idx_ai_call_logs_feature_created").on(table.feature, table.createdAt),
    agencyCreatedIdx: index("idx_ai_call_logs_agency_created").on(table.agencyId, table.createdAt),
  }),
);

export type AiCallLog = typeof aiCallLogs.$inferSelect;
export type InsertAiCallLog = typeof aiCallLogs.$inferInsert;
